import { useEffect, useRef, useState } from "react";
import { useTimelinesStore } from "./useTimelinesStore";
import { getPostTimeline, WatchAppApiStatusType } from "../Service";
import dayjs from "dayjs";
import { GAME_GENERAL_STATE, useGameGeneralState } from "./useGameGeneralState";
import { TimelineData } from "../Timeline/Types";
import { useFunFactsStore } from "../FunFacts/GamesFinFactsStore";

export const useTimelineData = (postId: string) => {
    const [isLoading, setIsLoading] = useState(true);
    const { setTimeline } = useTimelinesStore();
    const { setFunFacts } = useFunFactsStore();
    const [watchAppApiStatus, setWatchAppApiStatus] =
        useState<WatchAppApiStatusType>();
    const [localTimeline, setLocalTimeline] = useState<TimelineData>();

    useEffect(() => {
        getPostTimeline(postId).then((data) => {
            if (!data) {
                return;
            }
            const { timeline, funFacts, watchAppApiStatus } = data;
            setIsLoading(false);
            setLocalTimeline(timeline);
            setWatchAppApiStatus(watchAppApiStatus);
            !!funFacts.length && setFunFacts(postId, funFacts);
            timeline && setTimeline(postId, timeline);
        });
    }, []);

    const gameState = useGameGeneralState(localTimeline);

    const intervalIdRef = useRef<ReturnType<typeof setInterval>>();

    useEffect(() => {
        if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
        }
        if (!localTimeline) {
            return;
        }
        let interval = 5;
        const matchStartedAt = dayjs(localTimeline.sportEvent.startTime);
        if (gameState === GAME_GENERAL_STATE.CLOSED) {
            return;
        } else if (gameState === GAME_GENERAL_STATE.ENDED) {
            if (
                matchStartedAt < dayjs() &&
                matchStartedAt.diff(dayjs(), "h") <= 4
            ) {
                interval = 600;
            } else {
                return;
            }
        } else if (gameState === GAME_GENERAL_STATE.MATCH_ABOUT_TO_START) {
            interval = 5;
        } else if (
            matchStartedAt > dayjs() &&
            dayjs().diff(matchStartedAt, "m") <= 60 &&
            dayjs().diff(matchStartedAt, "m") >= 5
        ) {
            interval = 600;
        } else if (
            matchStartedAt > dayjs() &&
            dayjs().diff(matchStartedAt, "m") <= 5
        ) {
            interval = 60;
        }
        intervalIdRef.current = setInterval(() => {
            getPostTimeline(postId).then((data) => {
                if (!data) {
                    return;
                }
                const { timeline, funFacts, watchAppApiStatus } = data;
                setLocalTimeline(timeline);
                setWatchAppApiStatus(watchAppApiStatus);
                !!funFacts.length && setFunFacts(postId, funFacts);
                timeline && setTimeline(postId, timeline);
            });
        }, interval * 1000);
        return () => clearInterval(intervalIdRef.current);
    }, [localTimeline]);

    return { timeline: localTimeline, isLoading, watchAppApiStatus };
};
